"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowType_1 = require("../model/WindowType");

var WindowTypeConverter_1 = require("./WindowTypeConverter");
/**
 * Default implementation of WindowTypeConverter.
 *
 * @author ZSr
 */


var WindowTypeConverterImpl =
/*#__PURE__*/
function (_WindowTypeConverter_) {
  _inherits(WindowTypeConverterImpl, _WindowTypeConverter_);

  function WindowTypeConverterImpl() {
    _classCallCheck(this, WindowTypeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowTypeConverterImpl).apply(this, arguments));
  }

  _createClass(WindowTypeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowType_1.WindowType(WindowType_1.WindowType.schema.id.valueOf(conversions.documentToClassId(source)), WindowType_1.WindowType.schema.name.valueOfField(source), WindowType_1.WindowType.schema.priority.valueOfField(source), conversions.asObjectList(source, 'promotionTypes', function (id) {
        return id;
      }), conversions.asObjectList(source, 'defaultForPromotionTypes', function (a) {
        return a;
      }), source.classification, WindowType_1.WindowType.schema.blocked.valueOfField(source), WindowType_1.WindowType.schema.promoVolumeThresholdRel.valueOfField(source), WindowType_1.WindowType.schema.promoVolumeThresholdAbs.valueOfField(source), WindowType_1.WindowType.schema.promoVolumeThresholdEnabled.valueOfField(source), WindowType_1.WindowType.schema.systemVolumeThresholdRel.valueOfField(source), WindowType_1.WindowType.schema.systemVolumeThresholdAbs.valueOfField(source), WindowType_1.WindowType.schema.systemVolumeThresholdEnabled.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        priority: source.priority,
        promotionTypes: conversions.asObjectArray(source, 'promotionTypes', function (id) {
          return id;
        }),
        defaultForPromotionTypes: conversions.asObjectArray(source, 'defaultForPromotionTypes', function (a) {
          return a;
        }),
        blocked: source.blocked,
        classification: source.classification,
        promoVolumeThresholdRel: source.promoVolumeThresholdRel,
        promoVolumeThresholdAbs: source.promoVolumeThresholdAbs,
        promoVolumeThresholdEnabled: source.promoVolumeThresholdEnabled,
        systemVolumeThresholdRel: source.systemVolumeThresholdRel,
        systemVolumeThresholdAbs: source.systemVolumeThresholdAbs,
        systemVolumeThresholdEnabled: source.systemVolumeThresholdEnabled
      });
      return result;
    }
  }]);

  return WindowTypeConverterImpl;
}(WindowTypeConverter_1.WindowTypeConverter);

exports.WindowTypeConverterImpl = WindowTypeConverterImpl;